// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"buttonStyles_buttonWrapper__3-kWh","button":"buttonStyles_button__xiGzY","active":"buttonStyles_active__dmG77"};